
export enum CustomFieldParent {
    Quote = 'Quote',
    Job = 'Job',
    WorkOrder = 'WorkOrder',
    Account = 'Account',
    Contact = 'Contact',
    Zone = 'Zone',
    Code = 'Code',
    /** A line on a job stage, quote or pending request. Displayed as "Embedded Line": the fields describe one instance of a catalogue item, not the catalogue item itself. */
    EmbeddedItem = 'EmbeddedItem',
    Asset = 'Asset',
    Lead = 'Lead',
    Opportunity = 'Opportunity',
    Catalogue = 'Catalogue',
    Project = 'Project',
    Site = 'Site',
    Employee = 'Employee',
    Equipment = 'Asset',
    EquipmentSerialised = 'Asset',
}